import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

import { Card } from '../../../components/Card';
import { Repair } from '../../../data/Repair';
import { CardField } from '../../../components/Card/CardField';

type RepairCardProps = {
    repair: Repair,
    onClick: () => void,
};

RepairCard.defaultProps = {

};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        width: '100%',
        padding: theme.spacing(1),
    },
    button: {
        width: '100%',
    },
    fieldContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    moreIconContainer: {
        marginTop: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.grey['700'],
        fontSize: 16,
    },
}));

function RepairCard(props: RepairCardProps): React.ReactElement {
    const {
        repair,
        onClick,
    } = props;
    const classes = useStyle();

    return (
        <div className={classes.root}>
            <Card onClick={onClick} pointer>
                <div className={classes.fieldContainer}>
                    <CardField
                        label="報修單號"
                        value={repair.name}
                    />
                    <div></div>
                    <CardField
                        label="產品型號"
                        value={repair.product_model_id}
                    />
                    <CardField
                        label="回廠日"
                        value={repair.back_factory_date}
                    />
                    <CardField
                        label="產品序號"
                        value={repair.sn_code_id}
                    />
                    <CardField
                        label="出貨日"
                        value={repair.shipping_date}
                    />
                </div>
                <div className={classes.moreIconContainer}>
                    <Icon icon={faChevronDown} />
                </div>
            </Card>
        </div>
    );
}

export { RepairCard };
